import { Box, Autocomplete, Button, Grid, Grid2, IconButton, MenuItem, Menu, ListItemIcon, ListItemText, Paper, Radio, RadioGroup, FormControlLabel, FormControl, Select, Snackbar, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TableSortLabel, TextField, Typography, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import TokenError from '../tokenError';import {
    makeGetRequestToUrl,
    makePostRequestToUrl,
    importCSV,
    parseCSVLine,
    handleImportCSVWithCaseInsensitive,
    processBulkImport
} from '../commonFunc.jsx';
import config from '../../config/config.js';
import { useNavigate } from "react-router-dom";
import prevIcon from '../../assets/icons/left-arrow.svg';
import nextIcon from '../../assets/icons/right-arrow.svg';
import { useEffect, useRef, useState } from "react";
import { Label } from "flowbite-react";
import PhoneInput from 'react-phone-number-input';
import { parsePhoneNumber } from 'libphonenumber-js';
import CloseIcon from '@mui/icons-material/Close';
import threeDots from '../../assets/images/threeDots.svg';
import BlockImg from '../../assets/images/blockImg.svg';
import deleteImg from '../../assets/images/deleteImg.svg';
import { CSVLink } from "react-csv";
import exportCSVIcon from '../../assets/icons/exportCsvBlack.svg';
import importArrowIcon from '../../assets/images/importArrow.svg';
import { useGoogleMapsLoader } from "../../utils/GoogleMapsLoader";

const TruckVendors = () => {

    const serverUrl = config.serverUrl;
    const operationsUrl = config.operationsUrl;
    const navigate = useNavigate();
    const cities = JSON.parse(localStorage.getItem('cities'));

    const [cityFilter, setCityFilter] = useState(cities[0].city_id);
    const [tokenExpired, setTokenExpired] = useState(false);
    const [rows, setRows] = useState([]);
    const [order, setOrder] = useState('desc');
    const [orderBy, setOrderBy] = useState('truck_vendor_id');
    const [page, setPage] = useState(0);
    const [rowsPerPage] = useState(10);
    const [errorMessage, setErrorMessage] = useState('');
    const [snackbar, showSnackbar] = useState(false);
    const [message, setMessage] = useState('');
    const [truckerName, setTruckerName] = useState('');
    const [phone, setPhone] = useState('');
    const [countryCode, setCountryCode] = useState('');
    const [editable, setEditable] = useState(false);
    const [open, setOpen] = useState(false);
    const [email, setEmail] = useState('');
    const [emailError, setEmailError] = useState(false);
    const [address, setAddress] = useState('');
    const [truckVendorId, setTruckVendorId] = useState('');
    const [contractType, setContractType] = useState('1');
    const [formErrors, setFormErrors] = useState({
        truckerName: false,
        email: false,
        phone: false,
        address: false,
        contractType: false
    });
    
    const [menuAnchorEl, setMenuAnchorEl] = useState(null);
    const [selectedRow, setSelectedRow] = useState(null);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [confirmAction, setConfirmAction] = useState(''); // 'block' or 'delete'
    const [actionReason, setActionReason] = useState('');
    const [isReasonError, setIsReasonError] = useState(false);
    const [allData, setAllData] = useState([]);
    const [showTemplateButton, setShowTemplateButton] = useState(false);
    const [locationData, setLocationData] = useState([]);

    const inputRef = useRef(null);
    const fileInputRef = useRef(null);

    const handleClose = () => {
        setOpen(false);
        setEditable(false);
    }

    const handleRequestSort = (property) => {
        const isAscending = orderBy === property && order === 'asc';
        setOrder(isAscending ? 'desc' : 'asc');
        setOrderBy(property);
        const sortedRows = [...rows].sort((a, b) => {
            if (a[property] < b[property]) return isAscending ? -1 : 1;
            if (a[property] > b[property]) return isAscending ? 1 : -1;
            return 0;
        });
        setRows(sortedRows);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleCityChange = (e) =>{
        const city =  cities.find((cityObj) => cityObj.city_id === e)
        setCityFilter(e);
    }

    // const loaderOptions = {
    //     id: 'google-map-script',
    //     googleMapsApiKey: constants.API_KEY, // Replace with your actual API key
    //     libraries: LIBRARIES,
    // }

    const { isLoaded, loadError } = useGoogleMapsLoader();

    const formatDataForCSV = (data) => {
        return data ? (data.map((item) => ({
            ...item
        }))) : '';
    };

    // Define custom headers
    const headers = [
        { label: 'Truck Vendor ID', key: 'truck_vendor_id' },
        { label: 'Truck Vendor Name', key: 'name' },
        { label: 'Email', key: 'email' },
        { label: 'Phone Number', key: 'phone_no' },
        { label: 'Address', key: 'address' },
        { label: 'Contract Type', key: 'contract_type' },
        // { label: 'Status', key: 'status' }
    ];

    const fetchVendorsData = async() => {
        try {
            const token = localStorage.getItem('token');
            const url = serverUrl + '/transport/fetch_truck_vendors';
            const timestamp = new Date().getTime();
            const body = {
                token: token,
                city_id: cityFilter,
                timestamp: timestamp
            };
            const response =  await makeGetRequestToUrl(url, body);
            if(response.flag==200){
                // Sort data in descending order by truck_vendor_id before setting it
                const sortedData = [...response.data].sort((a, b) => {
                    if (a[orderBy] < b[orderBy]) return order === 'asc' ? -1 : 1;
                    if (a[orderBy] > b[orderBy]) return order === 'asc' ? 1 : -1;
                    return 0;
                });
                setRows(sortedData);
                const formattedData = formatDataForCSV(sortedData);
                setAllData(formattedData);
            }
            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
                // navigate('/signup');
            }
        }
        catch (error) {
            console.log('error', error);
        }
    }
    const fetchTmsLocation = async() => {
        try {
            const token = localStorage.getItem('token');
            const url = serverUrl + '/transport/fetch_locations';
            const timestamp = new Date().getTime();
            const body = {
                token: token,
                city_id: cityFilter,
                timestamp: timestamp
            };
            const response =  await makeGetRequestToUrl(url, body);
            if(response.flag==200){
                setLocationData(response.data);
            }
            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
                // navigate('/signup');
            }
        }
        catch (error) {
            console.log('error', error);
        }
    }

    useEffect(()=> {
        fetchVendorsData();
        fetchTmsLocation();
    },[cityFilter])

    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return; 
        }
        showSnackbar(false); 
    };
    
    const handleOpenAddVendors = () => {
        setOpen(true);
        setEditable(false);
        setAddress('');
        setEmail('');
        setPhone('');
        setCountryCode('');
        setContractType('1');
        setTruckerName('');
        setTruckVendorId('');
        setFormErrors({
            truckerName: false,
            email: false,
            phone: false,
            address: false,
            contractType: false
        });
    }

    const handleOpenEditVendors = (row) => {
        setOpen(true);
        setEditable(true);
        setAddress(row.location_id);
        setEmail(row.email);
        setPhone(row.phone_no);
        setContractType(row.contract_type);
        setTruckerName(row.name);
        setTruckVendorId(row.truck_vendor_id);
        setFormErrors({
            truckerName: false,
            email: false,
            phone: false,
            address: false,
            contractType: false
        });
    }

    const handleSubmit = async() =>{
        // Validate all required fields
        const errors = {
            truckerName: !truckerName.trim(),
            email: !email.trim() || emailError,
            phone: !phone,
            address: !address,
            contractType: !contractType
        };
        
        // Update error state
        setFormErrors(errors);
        
        // Check if any validation errors exist
        if (Object.values(errors).some(error => error)) {
            setMessage('Please fill in all required fields correctly');
            showSnackbar(true);
            return; // Prevent form submission
        }
        
        const token = localStorage.getItem('token');
        const payload = {
            token: token,
            city_id: cityFilter,
            name: truckerName,
            phone_no: phone,
            email: email,
            location_id: address,
            contract_type: contractType
        };
        if(editable && truckVendorId!=''){
            payload.truck_vendor_id = truckVendorId;
        }

        try {
            const url = operationsUrl + '/transport/add_update_truck_vendors';
            const response = await makePostRequestToUrl(url,payload);
            if (response.flag === 200) {
                setMessage(response.message)
                showSnackbar(true);
                handleClose();
                fetchVendorsData();
            } else {
                setMessage(response.message)
                showSnackbar(true);
            }

        } catch (error) {
            console.error('Error while saving document:', error);
            setMessage(error);
        }

    }

    const validateEmail = (value) => {
        const re = /^(([^<>()\[\]\\.,;:\s@\"]+(\.[^<>()\[\]\\.,;:\s@\"]+)*)|(".+"))@(([^<>()[\]\\.,;:\s@\"]+\.)+[^<>()[\]\\.,;:\s@\"]{2,})$/i;
        return re.test(String(value).toLowerCase());
    };

    const handleEmailChange = (e) => {
        const value = e.target.value;
        setEmail(value);
        setEmailError(value.length > 0 && !validateEmail(value));
    };

    useEffect(() => {
        const loadAutocomplete = () => {
            if (window.google && window.google.maps && window.google.maps.places) {
                const autocomplete = new window.google.maps.places.Autocomplete(inputRef.current, {
                    types: ['geocode']
                });
                autocomplete.addListener('place_changed', () => {
                    const place = autocomplete.getPlace();
                    if (place.geometry) {
                        setAddress(place.formatted_address || '')
                    }
                });
            }
        };

        loadAutocomplete();
    }, [open, editable]);

    // Menu handlers
    const handleMenuOpen = (event, row) => {
        setMenuAnchorEl(event.currentTarget);
        setSelectedRow(row);
    };

    const handleMenuClose = () => {
        setMenuAnchorEl(null);
    };

    const openConfirmDialog = (action, row) => {
        handleMenuClose();
        setConfirmAction(action);
        setSelectedRow(row);
        setActionReason('');
        setIsReasonError(false);
        setConfirmDialogOpen(true);
    };

    const handleConfirmClose = () => {
        setConfirmDialogOpen(false);
        setActionReason('');
        setIsReasonError(false);
    };

    const handleConfirmAction = async () => {
        // Validate reason is provided
        if (!actionReason.trim()) {
            setIsReasonError(true);
            return;
        }

        try {
            const token = localStorage.getItem('token');
            const payload = {
                token: token,
                truck_vendor_id: selectedRow.truck_vendor_id,
                reason: actionReason
            };
            if(confirmAction === 'block') {
                payload.status = 2;
            } else if (confirmAction === 'unblock') {
                payload.status = 1;
            } else if (confirmAction === 'delete') {
                payload.status = 3;
            }
            
            let url = operationsUrl + '/transport/add_update_truck_vendors';
            
            const response = await makePostRequestToUrl(url, payload);
            
            if (response.flag === 200) {
                setMessage(response.message);
                showSnackbar(true);
                fetchVendorsData(); // Refresh the list
            } else {
                setMessage(response.message || `Failed to ${confirmAction} truck vendor`);
                showSnackbar(true);
            }
        } catch (error) {
            console.error(`Error ${confirmAction}ing truck vendor:`, error);
            setMessage(`An error occurred while ${confirmAction}ing the truck vendor`);
            showSnackbar(true);
        } finally {
            handleConfirmClose();
        }
    };

    const handleReasonChange = (e) => {
        setActionReason(e.target.value);
        if (e.target.value.trim()) {
            setIsReasonError(false);
        }
    };

    //import csv
    const requiredColumns = ['name', 'email', 'phone_no', 'contract_type'];
    
    // Function to download template CSV file
    const downloadCSVTemplate = () => {
        const headers = ['name', 'email', 'phone_no', 'contract_type'];
        const csvContent = headers.join(',') + '\n' + 'Vendor Name,vendor@example.com,9876543210,Dedicated';
        
        // Create a blob and download
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'TruckVendors_Template.csv');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const alternativeColumns = {
        'name': ['Name', 'name', 'NAME', 'Truck Vendor Name'],
        'email': ['Email', 'email', 'EMAIL', 'Email'],
        'phone_no': ['Phone Number', 'phone_no', 'PHONE_NO', 'Phone_Number', 'Phone'],
        'contract_type': ['Contract Type', 'contract_type', 'CONTRACT_TYPE', 'Contract_Type'],
    };

    // Handle CSV import
    const handleImportCSV = (event) => {
        const file = event.target.files[0];
        if (!file) {
            setMessage('No file selected');
            showSnackbar(true);
            return;
        }
        
        console.log('File selected for import:', file.name, 'Size:', file.size, 'Type:', file.type);
        
        // Use the imported handleImportCSVWithCaseInsensitive function
        handleImportCSVWithCaseInsensitive(
            file,
            // Success callback
            async (data, headers) => {
                try {
                    if (!data || data.length === 0) {
                        setMessage('CSV file contains no data');
                        showSnackbar(true);
                        return;
                    }
                    
                    // Process the import using the new shared function
                    const result = await processLocationImport(data);
                    
                    // Display result message
                    setMessage(result.message);
                    showSnackbar(true);
                    
                    // Refresh data if successful
                    if (result.success) {
                        fetchVendorsData();
                    }
                    
                    // Reset file input
                    event.target.value = '';
                } catch (error) {
                    console.error('Error processing imported data:', error);
                    setMessage('Error processing imported data');
                    showSnackbar(true);
                    event.target.value = '';
                }
            },
            // Error callback
            (error) => {
                console.error('CSV import error:', error);
                let errorMessage = 'Error importing CSV file';
                
                // If we have specific missing columns info
                if (error.missingColumns) {
                    errorMessage = `CSV is missing required columns: ${error.missingColumns.join(', ')}`;
                    // Show template download button in snackbar
                    setShowTemplateButton(true);
                } else if (typeof error === 'string') {
                    errorMessage = error;
                    setShowTemplateButton(false);
                } else if (error.message) {
                    errorMessage = error.message;
                    setShowTemplateButton(false);
                }
                
                setMessage(errorMessage);
                showSnackbar(true);
                event.target.value = '';
            },
            requiredColumns,
            alternativeColumns
        );
    };
    
    // Process imported location data using the shared processBulkImport function
    const processLocationImport = async (data) => {
        const token = localStorage.getItem('token');
        const url = operationsUrl + '/transport/add_bulk_truck_vendors';
        console.log('data')
        
        // Map function to convert CSV data to the expected API format
        const mapLocationData = (item) => {
            // Create location object from CSV data
            const locationData = {
                city_id: cityFilter,
                name: item.name || item['Name'] || '',
                email: item.email || item['Email'] || '',
                phone_no: item.phone_no || item['Phone No'] || '',
                contract_type: item.contract_type || item['Contract Type'] || '',
            };
            console.log('locationData', locationData)
            
            // Return null for invalid entries (will be filtered out)
            if (!locationData.name || !locationData.email || !locationData.phone_no || !locationData.contract_type) {
                console.warn('Skipping invalid truck vendor:', item);
                return null;
            }
            
            return locationData;
        };
        
        // Use the shared processBulkImport function
        return await processBulkImport(data, token, url, 'truck_vendors', mapLocationData);
    };

    return(
        <div>
            {tokenExpired && (<TokenError/>)}

            <Typography style={{ fontSize: '28px', fontWeight: '500' }}>
                Truck Vendors
            </Typography>

            <Grid2 container spacing={2} alignItems="center" style={{ marginTop: '2%', marginBottom: '3%' }}>
                <Grid2 item>
                <Select value={cityFilter} 
                    onChange={(e) => handleCityChange(e.target.value)} displayEmpty
                    style={{width: '190px',height:'50px',borderRadius:'8px',backgroundColor: cityFilter ? '#F9F9F9' : '#FFFFFF'}}>
                        <MenuItem value="">Select City</MenuItem>
                        {cities.map((city) => (
                            <MenuItem key={city.city_name} value={city.city_id}>
                                {city.city_name}
                            </MenuItem>
                        ))}
                    </Select>
                </Grid2>
                <Grid2 item>
                    <Button
                        variant="contained"
                        onClick={handleOpenAddVendors}
                        style={{
                            width: '185px',
                            height: '50px',
                            backgroundColor: '#000000',
                            textTransform: 'none',
                            borderRadius: '8px',
                        }}
                    >
                        + Add Truck Vendors
                    </Button>
                </Grid2>
                <Grid2 item sx={{ marginLeft: "auto", display: 'flex', alignItems: 'center', gap: 2 }}>
                    <input
                        type="file"
                        accept=".csv, .numbers"
                        ref={fileInputRef}
                        onChange={handleImportCSV}
                        style={{ display: 'none' }}
                    />
                    <Button
                        variant="outlined"
                        onClick={() => downloadCSVTemplate()}
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            border: '1.5px solid #111',
                            background: '#fff',
                            color: '#111',
                            borderRadius: '14px',
                            minWidth: '180px',
                            height: '48px',
                            fontWeight: 500,
                            fontSize: '22px',
                            textTransform: 'none',
                            boxShadow: 'none',
                            transition: 'background 0.2s',
                            '&:hover': {
                                background: '#f9f9f9',
                                borderColor: '#111',
                                color: '#111',
                                boxShadow: 'none',
                            },
                        }}
                    >
                        <img src={importArrowIcon} alt="Import CSV" style={{ width: 20, height: 20, marginRight: 8, marginTop: 2 }} />
                        <span style={{ fontWeight: 500, fontSize: 16 }}>Sample CSV</span>
                    </Button>

                    <Button
                        variant="outlined"
                        onClick={() => fileInputRef.current.click()}
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            border: '1.5px solid #111',
                            background: '#fff',
                            color: '#111',
                            borderRadius: '14px',
                            minWidth: '180px',
                            height: '48px',
                            fontWeight: 500,
                            fontSize: '22px',
                            textTransform: 'none',
                            boxShadow: 'none',
                            transition: 'background 0.2s',
                            '&:hover': {
                                background: '#f9f9f9',
                                borderColor: '#111',
                                color: '#111',
                                boxShadow: 'none',
                            },
                        }}
                    >
                        <img src={importArrowIcon} alt="Import CSV" style={{ width: 20, height: 20, marginRight: 8, marginTop: 2 }} />
                        <span style={{ fontWeight: 500, fontSize: 16 }}>Import CSV</span>
                    </Button>

                    <Button
                        variant="outlined"
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            border: '1.5px solid #111',
                            background: '#fff',
                            color: '#111',
                            borderRadius: '14px',
                            minWidth: '180px',
                            height: '48px',
                            fontWeight: 500,
                            fontSize: '22px',
                            textTransform: 'none',
                            boxShadow: 'none',
                            transition: 'background 0.2s',
                            '&:hover': {
                                background: '#f9f9f9',
                                borderColor: '#111',
                                color: '#111',
                                boxShadow: 'none',
                            },
                        }}
                    >
                        <CSVLink
                            data={allData}
                            headers={headers}
                            filename={"Truck Vendors Data.csv"}
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 10,
                                textDecoration: 'none',
                                color: 'inherit',
                                width: '100%',
                                justifyContent: 'center',
                            }}
                        >
                            <span style={{ fontWeight: 500, fontSize: 16 }}>Export CSV</span>
                            <img src={exportCSVIcon} alt="Export CSV" style={{ width: 18, height: 18, marginLeft: 4, marginTop: 2 }} />
                        </CSVLink>
                    </Button>
                </Grid2>
            </Grid2>

            {open && (
                <div 
                    style={{position: 'fixed',top: 65, right:0, height: '100%',width: '50%',backgroundColor: '#f9f9f9',
                        boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',transition: 'right 0.3s ease-in-out',
                        zIndex: 1000,overflowY: 'auto',padding: 20
                    }}>
                    <Box>
                        <div style={{ position: 'relative', padding: '40px 0' }}>
                            <IconButton aria-label="close" onClick={handleClose}
                                style={{
                                    position: 'absolute',top: '-15px',left: '1px',color: '#333',zIndex: 10}}>
                                <CloseIcon style={{ fontSize: '32px', fontWeight: 'bold' }} />
                            </IconButton>
                            <Paper elevation={3}
                                style={{ padding: '30px', maxWidth: '800px', margin: '0 auto',
                                    backgroundColor: '#FFFFFF', borderRadius: '12px'}}>
                                <Typography variant="h6" style={{ marginBottom: '20px', marginTop: '20px', fontWeight: 'bold' }}>
                                    {editable ? 'Edit Truck Vendors' : 'Add Truck Vendors'}
                                </Typography>

                                <Grid container spacing={2}>
                                    
                                    <Grid item xs={12} sm={12}>
                                        <Label style={{color:'#1A1E25', fontSize:'16px'}}>Truck Vendor Name<span style={{ color: 'red' }}>*</span></Label>
                                        {formErrors.truckerName && <Typography sx={{ color: '#d32f2f', fontSize: '0.75rem', mt: 0.5 }}>Truck Vendor Name is required</Typography>}
                                        <TextField sx={{marginTop:'1%'}} placeholder="Truck Vendor Name" fullWidth variant="outlined" type="text"
                                            value={truckerName} 
                                            onChange={(e) => {
                                                setTruckerName(e.target.value);
                                                setFormErrors({...formErrors, truckerName: !e.target.value.trim()});
                                            }}
                                            error={formErrors.truckerName}
                                            InputProps={{
                                                inputProps: { min: 0 }, // Prevent values less than zero
                                                style: {
                                                    height: '52px',
                                                    borderRadius:'12px',
                                                    fontSize: '16px',
                                                    padding: '8px 14px',
                                                    backgroundColor: '#FFFFFF',
                                                },
                                            }}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={12}>
                                        <Label style={{color:'#1A1E25', fontSize:'16px'}}>Address<span style={{ color: 'red' }}>*</span></Label>
                                        {formErrors.address && <Typography sx={{ color: '#d32f2f', fontSize: '0.75rem', mt: 0.5 }}>Address is required</Typography>}
                                        
                                        <Select
                                            sx={{
                                                marginTop: '2%',
                                                height: '50px',
                                                borderRadius:'12px',
                                                backgroundColor: '#FFFFFF',
                                                border: formErrors.address ? '1px solid #d32f2f' : 'none',
                                                '& .MuiSelect-select': {
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: '8px'
                                                }
                                            }}
                                            fullWidth
                                            value={address}
                                            onChange={(e) => {
                                                setAddress(e.target.value);
                                                setFormErrors({...formErrors, address: !e.target.value});
                                            }}
                                            error={formErrors.address}
                                            displayEmpty
                                        >
                                            <MenuItem value="" disabled>
                                                <Typography sx={{ color: '#666' }}>Select Address</Typography>
                                            </MenuItem>
                                            {locationData.map((location) => (
                                                <MenuItem key={location.location_id} value={location.location_id}>
                                                    {location.name}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </Grid>

                                    <Grid item xs={12} sm={6}>
                                    <Label style={{color:'#1A1E25', fontSize:'16px'}}>Truck Vendor Email<span style={{ color: 'red' }}>*</span></Label>
                                    {formErrors.email && !emailError && <Typography sx={{ color: '#d32f2f', fontSize: '0.75rem', mt: 0.5 }}>Email is required</Typography>}
                                    <TextField sx={{marginTop:'1%'}} placeholder="Email" fullWidth variant="outlined" type="email"
                                        value={email} 
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            setEmail(value);
                                            setEmailError(value.length > 0 && !validateEmail(value));
                                            setFormErrors({...formErrors, email: !value.trim()});
                                        }}
                                        error={emailError || formErrors.email}
                                        helperText={emailError ? "Please enter a valid email address" : ""}
                                        InputProps={{
                                            inputProps: { min: 0 }, // Prevent values less than zero
                                            style: {
                                                height: '52px',
                                                borderRadius:'12px',
                                                fontSize: '16px',
                                                padding: '8px 14px',
                                                backgroundColor: '#FFFFFF',
                                            },
                                        }}
                                    />
                                    </Grid>

                                    <Grid item xs={12} sm={6}>
                                        <Label style={{color:'#1A1E25', fontSize:'16px'}}>Truck Vendor Phone Number<span style={{ color: 'red' }}>*</span></Label>
                                        {formErrors.phone && <Typography sx={{ color: '#d32f2f', fontSize: '0.75rem', mt: 0.5 }}>Phone Number is required</Typography>}
                                        <PhoneInput
                                            defaultCountry="IN"
                                            value={phone}
                                            onChange={(value) => {
                                                setPhone(value);
                                                // Update validation state
                                                setFormErrors({...formErrors, phone: !value});
                                                try {
                                                    const parsed = parsePhoneNumber(value);
                                                    if (parsed) {
                                                        setCountryCode(parsed.countryCallingCode ? `+${parsed.countryCallingCode}` : '');
                                                    }
                                                } catch (err) {
                                                    console.error('Invalid phone number:', err);
                                                    setCountryCode('');
                                                }
                                            }}
                                            className={formErrors.phone ? 'error-border' : ''}
                                            placeholder="Enter phone number"
                                            style={{
                                                height: '44px',
                                                fontSize: '16px',
                                                alignItems: 'normal', 
                                                marginTop:'2%',
                                                border: formErrors.phone ? '1px solid #d32f2f' : 'none',
                                                borderRadius: '8px'
                                            }}
                                        />
                                    </Grid>

                                </Grid>

                                <Grid2 sx={{border: formErrors.contractType ? '1px solid #d32f2f' : '1px solid #D1D5DB', borderRadius:'12px', padding:'8px', marginTop:'16px'}}>
                                    <Grid2 sx={{fontSize:'16px', fontWeight:'500', backgroundColor:'#F9F9F9', padding:'8px 14px', borderRadius:'8px'}}>
                                        Contract Type<span style={{ color: 'red' }}>*</span>
                                    </Grid2>
                                    {formErrors.contractType && <Typography sx={{ color: '#d32f2f', fontSize: '0.75rem', mt: 0.5, ml: 2 }}>Contract Type is required</Typography>}
                                    <Grid2 container spacing={2} sx={{justifyContent:'space-between', marginTop:'2%', px: 2, py: 3}}>
                                        <FormControl component="fieldset">
                                            <RadioGroup
                                                row
                                                aria-label="contract-type"
                                                name="contract-type"
                                                value={contractType}
                                                onChange={(e) => {
                                                    setContractType(e.target.value);
                                                    setFormErrors({...formErrors, contractType: !e.target.value});
                                                }}
                                                sx={{
                                                    width: '100%',
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    gap: '30px',
                                                    '& .MuiFormControlLabel-root': {
                                                        flex: 1,
                                                        margin: 0,
                                                        minWidth: '40%',
                                                    }
                                                }}
                                            >
                                                <FormControlLabel 
                                                    value="1" 
                                                    control={
                                                        <Radio sx={{'&.Mui-checked': {color: '#6B7280' }}}/>
                                                    } 
                                                    label={
                                                        <Typography sx={{ color: '#6B7280', fontSize: '16px' }}>
                                                            Lease
                                                        </Typography>
                                                    }
                                                />
                                                <FormControlLabel 
                                                    value="2" 
                                                    control={
                                                        <Radio sx={{'&.Mui-checked': {color: '#6B7280'}}}/>
                                                    } 
                                                    label={
                                                        <Typography sx={{ color: '#6B7280', fontSize: '16px' }}>
                                                            Spot Hire
                                                        </Typography>
                                                    }
                                                />
                                            </RadioGroup>
                                        </FormControl>
                                    </Grid2>
                                </Grid2>

                                <div style={{ marginTop: '40px', display: 'flex', justifyContent: 'center', gap: '20px' }}>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={handleSubmit}
                                        sx={{width: '140px',height: '50px',textTransform: 'none',
                                            fontSize: '16px',backgroundColor: '#0065FF',color: 'white'}}>
                                        {editable ? 'Update' : 'Save'}
                                    </Button>
                                    <Button
                                        variant="contained"
                                        onClick={handleClose}
                                        sx={{
                                            width: '140px',
                                            height: '50px',
                                            textTransform: 'none',
                                            fontSize: '16px',
                                            backgroundColor: '#F0F0F0',
                                            color: '#B0B0B0',
                                        }}
                                    >
                                        Cancel
                                    </Button>
                                </div>
                            </Paper>

                        </div>
                    </Box>
                </div>
            )}

            <TableContainer className="table-container">
                <Table stickyHeader className="scrollable-table">
                    <TableHead>
                        <TableRow>
                            <TableCell align="center" className="table-header">
                                <TableSortLabel
                                    active={orderBy === 'truck_vendor_id'}
                                    direction={orderBy === 'truck_vendor_id' ? order : 'asc'}
                                    onClick={() => handleRequestSort('truck_vendor_id')}
                                >
                                    Truck Vendor ID
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header">
                                <TableSortLabel
                                    active={orderBy === 'name'}
                                    direction={orderBy === 'name' ? order : 'asc'}
                                    onClick={() => handleRequestSort('name')}
                                >
                                    Name
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header">
                                <TableSortLabel
                                    active={orderBy === 'phone_no'}
                                    direction={orderBy === 'phone_no' ? order : 'asc'}
                                    onClick={() => handleRequestSort('phone_no')}
                                >
                                    Phone
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header">
                                <TableSortLabel
                                    active={orderBy === 'email'}
                                    direction={orderBy === 'email' ? order : 'asc'}
                                    onClick={() => handleRequestSort('email')}
                                >
                                    Email
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header">
                                <TableSortLabel
                                    active={orderBy === 'address'}
                                    direction={orderBy === 'address' ? order : 'asc'}
                                    onClick={() => handleRequestSort('address')}
                                >
                                    Address
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header">Actions</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rows.length === 0 && (
                            <TableRow>
                                <TableCell colSpan={6} align="center">
                                    <Typography variant="body1">No data found</Typography>
                                </TableCell>
                            </TableRow>
                        )}
                        {(rowsPerPage > 0
                            ? rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                            : rows
                        ).map((row) => (
                            <TableRow key={row.truck_vendor_id}>
                                <TableCell>{row.truck_vendor_id}</TableCell>
                                <TableCell>{row.name}</TableCell>
                                <TableCell>{row.phone_no}</TableCell>
                                <TableCell>{row.email}</TableCell>
                                <TableCell>{row.address}</TableCell>
                                <TableCell>
                                    <Button
                                        variant="contained"
                                        onClick={() => handleOpenEditVendors(row)}
                                        sx={{
                                            backgroundColor: '#EFFBF7', color: '#0DBA78', border: '1px solid #0DBA78', textTransform: 'none',
                                            borderRadius: '8px', minWidth:'40px', boxShadow:'none', width:"90px",
                                            '&:hover': {backgroundColor: '#0DBA78', color: 'white'},
                                            '&:active': { backgroundColor: '#0DBA78', color: 'white'}
                                        }}>
                                        
                                        <Typography sx={{marginRight:'6%'}}>Edit</Typography>
                                    </Button>

                                    <IconButton 
                                        aria-label="more options" 
                                        size="small"
                                        onClick={(e) => handleMenuOpen(e, row)}
                                        sx={{ marginLeft: '4px' }}
                                    >
                                        <img src={threeDots} alt="threeDots"/>
                                    </IconButton>
                                    
                                    <Menu
                                        anchorEl={menuAnchorEl}
                                        open={Boolean(menuAnchorEl) && selectedRow?.truck_vendor_id === row.truck_vendor_id}
                                        onClose={handleMenuClose}
                                        PaperProps={{
                                            elevation: 3,
                                            sx: {
                                                borderRadius: '8px',
                                                minWidth: '160px',
                                                padding: '4px 0',
                                                overflow: 'visible',
                                                '&:before': {
                                                    content: '""',
                                                    display: 'block',
                                                    position: 'absolute',
                                                    top: 0,
                                                    right: 14,
                                                    width: 10,
                                                    height: 10,
                                                    bgcolor: 'background.paper',
                                                    transform: 'translateY(-50%) rotate(45deg)',
                                                    zIndex: 0,
                                                },
                                            },
                                        }}
                                        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                                        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                                    >
                                        <MenuItem onClick={() => openConfirmDialog(row.status === 2 ? 'unblock' : 'block', row)} sx={{ py: 1 }}>
                                            <ListItemText primary={row.status === 2 ? "Unblock" : "Block"} sx={{ color: '#6B7280' }} />
                                            <ListItemIcon>
                                                <img src={BlockImg} alt="block"/>
                                            </ListItemIcon>
                                        </MenuItem>
                                        <MenuItem onClick={() => openConfirmDialog('delete', row)} sx={{ py: 1 }}>
                                            <ListItemText primary="Delete" sx={{ color: '#6B7280' }} />
                                            <ListItemIcon>
                                                <img src={deleteImg} alt="delete"/>
                                            </ListItemIcon>
                                        </MenuItem>
                                    </Menu>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
                <div className="custom-pagination">
                    <div className="pagination-info">
                        {`Showing ${page * rowsPerPage + 1} to ${Math.min(
                            (page + 1) * rowsPerPage,
                            rows.length
                        )} of ${rows.length} entries`}
                    </div>
                    <div className="pagination-controls">
                        <button
                            onClick={() => handleChangePage(null, page - 1)}
                            disabled={page === 0}
                            className="pagination-arrow"
                        >
                            <img src={prevIcon} alt="Previous" />
                        </button>
                        <div className="pagination-numbers">
                            {[...Array(Math.ceil(rows.length / rowsPerPage))].map((_, index) => (
                                <button key={index} onClick={() => handleChangePage(null, index)}
                                    className={`pagination-number ${page === index ? 'active' : ''}`}>
                                    {index + 1}
                                </button>
                            ))}
                        </div>
                        <button
                            onClick={() => handleChangePage(null, page + 1)}
                            disabled={page >= Math.ceil(rows.length / rowsPerPage) - 1}
                            className="pagination-arrow"
                        >
                            <img src={nextIcon} alt="Next" />
                        </button>
                    </div>
                </div>
            </TableContainer>

            <Snackbar open={snackbar} autoHideDuration={2000} onClose={handleSnackbarClose} message={message}></Snackbar>

            {/* Confirmation Dialog for Block/Delete */}
            <Dialog
                open={confirmDialogOpen}
                onClose={handleConfirmClose}
                aria-labelledby="confirm-dialog-title"
                aria-describedby="confirm-dialog-description"
                PaperProps={{
                    sx: {
                        borderRadius: '12px',
                        padding: '8px',
                        maxWidth: '500px',
                        width: '100%'
                    }
                }}
            >
                <DialogTitle id="confirm-dialog-title" sx={{ fontWeight: '600', fontSize: '20px' }}>
                    {confirmAction === 'block' ? 'Block Truck Vendor' : 
                     confirmAction === 'unblock' ? 'Unblock Truck Vendor' : 'Delete Truck Vendor'}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="confirm-dialog-description" sx={{ color: '#4B5563', mb: 2 }}>
                        Are you sure you want to {confirmAction} this truck vendor? Please provide a reason.
                    </DialogContentText>
                    <TextField
                        autoFocus
                        label="Reason"
                        type="text"
                        fullWidth
                        value={actionReason}
                        onChange={handleReasonChange}
                        error={isReasonError}
                        helperText={isReasonError ? "Please provide a reason" : ""}
                        sx={{
                            '& .MuiOutlinedInput-root': {
                                borderRadius: '8px',
                            }
                        }}
                        multiline
                        rows={3}
                    />
                </DialogContent>
                <DialogActions sx={{ padding: '16px' }}>
                    <Button 
                        onClick={handleConfirmClose} 
                        sx={{ 
                            textTransform: 'none', 
                            backgroundColor: '#F0F0F0', 
                            color: '#6B7280',
                            borderRadius: '8px',
                            padding: '8px 16px',
                            '&:hover': { backgroundColor: '#E0E0E0' }
                        }}
                    >
                        Cancel
                    </Button>
                    <Button 
                        onClick={handleConfirmAction} 
                        autoFocus
                        sx={{ 
                            textTransform: 'none', 
                            backgroundColor: confirmAction === 'delete' ? '#EF4444' : 
                                             confirmAction === 'block' ? '#F59E0B' : '#22C55E',
                            color: 'white',
                            borderRadius: '8px',
                            padding: '8px 16px',
                            '&:hover': { 
                                backgroundColor: confirmAction === 'delete' ? '#DC2626' : 
                                                 confirmAction === 'block' ? '#D97706' : '#16A34A'
                            }
                        }}
                    >
                        {confirmAction === 'block' ? 'Block' : 
                         confirmAction === 'unblock' ? 'Unblock' : 'Delete'}
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}

export default TruckVendors;